import { isArray } from 'class-validator';

const buildQueryString = (data) => Object.keys(data)
  .filter((option) => (isArray(data[option]) ? Boolean(data[option].length) : data[option]))
  .map((key) => `${key}=${data[key]}`)
  .join('&');

export default buildQueryString;
